import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";

export const INPUT_CLASS =
  "h-11 rounded-[8px] border border-[color:var(--line)] bg-[color:var(--card)] focus-visible:ring-0 focus-visible:ring-offset-0 focus-visible:border-[#DDA15E]";

// Page frame shared by the online screens (same column and type as the setup screen).
export function OnlineShell({ testId, kicker, title, intro, back = "/", backLabel = "Home", children }) {
  return (
    <div data-testid={testId} className="h-screen overflow-y-auto w-full flex justify-center px-4 py-8">
      <div className="w-full max-w-2xl my-auto">
        <Link to={back} className="btn-ghost -ml-3" data-testid="online-back-link">
          <ArrowLeft size={16} strokeWidth={1.8} /> {backLabel}
        </Link>
        <div className="mt-4 mb-6">
          <div className="label-kicker text-[color:var(--ink-3)]">{kicker}</div>
          <h1 className="font-display text-4xl sm:text-5xl font-bold tracking-tight text-[color:var(--ink)] mt-2" data-testid="online-title">
            {title}
          </h1>
          {intro && <p className="mt-2 text-[color:var(--ink-3)] max-w-md leading-relaxed">{intro}</p>}
        </div>
        {children}
      </div>
    </div>
  );
}

export function Panel({ testId, children, className = "" }) {
  return (
    <div data-testid={testId} className={`bg-[color:var(--card)] rounded-[10px] shadow-[var(--shadow-card)] p-7 ${className}`}>
      {children}
    </div>
  );
}

export function FieldError({ testId, children }) {
  if (!children) return null;
  return (
    <p data-testid={testId} role="alert" className="mt-3 text-sm" style={{ color: "var(--danger)" }}>
      {children}
    </p>
  );
}
